import { render, staticRenderFns } from "./AppointmentTypeCard.vue?vue&type=template&id=80c7f1f0"
import script from "./AppointmentTypeCard.vue?vue&type=script&lang=js"
export * from "./AppointmentTypeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports